import { create } from 'zustand';

interface PaymentCard {
  id: string;
  maskedCardNumber: string;
  cardType: string;
  createdOn: string;
  isDefault: boolean;
}

type PaymentCardsStore = {
  paymentCards: PaymentCard[];
  setPaymentCards: (cards: PaymentCard[]) => void;
};

const usePaymentCardsStore = create<PaymentCardsStore>((set) => ({
  paymentCards: [],
  setPaymentCards: (cards) => set({ paymentCards: cards })
}));

export { usePaymentCardsStore };
